<div class="floating-input" [class.has-value]="control().value">
  <label class="floating-input__label">{{ label() }}</label>
  <input
    class="floating-input__field"
    [type]="type()"
    [formControl]="control()"
    (keydown.enter)="enterPressed.emit()"
  />
</div>
<div class="floating-input__error">
  <ng-content />
</div>
